import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/video/opnform-ai.mp4")